export interface HasilEvaluasiMain {
  id: number;
  ulid: string;
  upaya_pengelolaan_risiko: string;
  penurunan_tingkat_risiko: string;
  kuadran: string;
  warna_kuadran: string;
  warna: string;
  posisi: number
  kesimpulan: string;
  is_upaya_range: boolean;
  is_penurunan_range: boolean;
  created_at: string;
  updated_at: string;
  grid_column: number;
  grid_row: number;
  x: string[],
  y: string[]
}

export interface HasilEvaluasiDataModel {
  main: {
    data: HasilEvaluasiMain[];
    total: number;
  };
}

export enum HasilEvaluasiActionType {
  GetHasilEvaluasi = "⌘➝Parameter Setting➝Scoring➝GetHasilEvaluasi",
}

export type HasilEvaluasiAction = {
  type: HasilEvaluasiActionType.GetHasilEvaluasi;
  data: {
    data: HasilEvaluasiMain[];
    total: number;
  };
};
